var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-link',_vm._g(_vm._b({staticClass:"LineLink",class:_vm.classes},'base-link',_vm.$attrs,false),_vm.$listeners),[_c('span',{class:['LineLink__text', { 't-align-fix': _vm.size !== 'inherit' }]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }